import type { IconProps } from '../types/IconProps.ts';
export const Redo2: IconProps = {
    name: 'Redo2',
    children: [
        `<path d="M20 9H9.5a5.5 5.5 0 1 0 0 11H12" />`,
        `<path d="m15 4 4.86 4.86a.2.2 0 0 1 0 .28L15 14" />`,
    ]
};